import axios from 'axios';
import Cookies from 'js-cookie';
import { getAuthHeader } from './userInfo-actions';

const jwtCookie = Cookies.get(
  `${process.env.REACT_APP_API_COOKIE_CONSTANT}`
);

export const bookProduct = async (
  bookName,
  idAcademy,
  origin,
  productType
) => {
  const bookData = await axios.post(
    `${process.env.REACT_APP_API_PATH_SLS_COMMERCE}/products/details`,
    {
      bookName,
      idAcademy,
      origin,
      productType
    },
    { headers: getAuthHeader(jwtCookie) }
  );
  if (bookData.data) {
    let price = (bookData.data.data[0].costInCents / 100).toFixed(2);
    price = price.split('.');
    bookData.data.data[0].price = price[0];
    const cents = price[1];
    bookData.data.data[0].cents = cents;
    return bookData.data;
  }
  return false;
};

export const accesBook = async libro => {
  let access = await axios.get(
    `${process.env.REACT_APP_API_BUY_PRODUCT}/book/user/paid`,
    {
      params: { libro, filter: true },
      headers: getAuthHeader(jwtCookie)
    }
  );
  if (access.data.response) {
    return true;
  }
  return false;
};

export const getShareLink = async (idObject, idType) => {
  const link = await axios.post(
    `${process.env.REACT_APP_API_PATH_PAYMENTBACK}/payFastBuy`,
    {
      co: 'Mayahii',
      currency: 'MXN',
      idObject,
      idType,
      locale: 'es',
      type: 'link',
      version: '0.1'
    },
    { headers: getAuthHeader(jwtCookie) }
  );
  if (link.data.reference) {
    return link.data.reference;
  }
  return false;
};

export const courseDetails = async idCourse => {
  let details = await axios.get(
    `${process.env.REACT_APP_API_PATH_COURSE}/course`,
    {
      params: { idCourse, origin: 'EDUSTORE' },
      headers: getAuthHeader(jwtCookie)
    }
  );
  if (details.data.courseVO) {
    let price = (details.data.courseVO.monto / 100).toFixed(2);
    price = price.split('.');
    details.data.courseVO.price = price[0];
    const cents = price[1];
    details.data.courseVO.cents = cents;
    return details.data.courseVO;
  }
  return false;
};

export const accesCourse = async (idCourse, idEmisorOriginal) => {
  let access = await axios.get(
    `${process.env.REACT_APP_API_PATH_MAYAHII_USER_DATA}/course/access`,
    {
      params: { idCourse, idEmisorOriginal },
      headers: getAuthHeader(jwtCookie)
    }
  );
  return access.data;
};

export const lessonsCourse = async idCourse => {
  let lessonsData = await axios.get(
    `${process.env.REACT_APP_API_COURSE_DATA}/lesson`,
    {
      params: { idCourse },
      headers: getAuthHeader(jwtCookie)
    }
  );
  if (lessonsData.data.lstLessonVO) {
    return lessonsData.data.lstLessonVO;
  }
  return false;
};

export const materialCourse = async idCourse => {
  let material = await axios.get(
    `${process.env.REACT_APP_API_PATH_COURSE}/course/material`,
    {
      params: { idCourse },
      headers: getAuthHeader(jwtCookie)
    }
  );
  if (material.data.lstMaterialVO) {
    return material.data.lstMaterialVO;
  }
  return false;
};

export const usersInCourse = async idCourse => {
  let users = await axios.get(
    `${process.env.REACT_APP_API_PATH_STATISTIC}/stat/course/user/progress`,
    {
      params: { idCourse },
      headers: getAuthHeader(jwtCookie)
    }
  );
  if (users.data.progress) {
    return users.data.progress;
  }
  return false;
};

export const trailerCourse = async (courseId, academyId) => {
  let users = await axios.get(
    `${process.env.REACT_APP_API_PATH_TRAILER}/video/trailer`,
    {
      params: { courseId, academyId },
      headers: getAuthHeader(jwtCookie)
    }
  );
  if (users.data.progress) {
    return users.data.progress;
  }
  return false;
};

export const courseReviews = async idCourse => {
  let reviews = await axios.get(
    `${process.env.REACT_APP_API_PATH_COURSE}/course/reviews`,
    {
      params: { idCourse },
      headers: getAuthHeader(jwtCookie)
    }
  );
  if (reviews.data.reviews) {
    let reviewsStars = [];
    const courseReviews = reviews.data.reviews;
    if (courseReviews.starGroups) {
      reviewsStars.push({
        value: courseReviews.starGroups.fiveStars,
        star: 5
      });
      reviewsStars.push({
        value: courseReviews.starGroups.fourStars,
        star: 4
      });
      reviewsStars.push({
        value: courseReviews.starGroups.threeStars,
        star: 3
      });
      reviewsStars.push({
        value: courseReviews.starGroups.twoStars,
        star: 2
      });
      reviewsStars.push({
        value: courseReviews.starGroups.oneStar,
        star: 1
      });
    } else {
      reviewsStars.push({ value: 0, star: 5 });
      reviewsStars.push({ value: 0, star: 4 });
      reviewsStars.push({ value: 0, star: 3 });
      reviewsStars.push({ value: 0, star: 2 });
      reviewsStars.push({ value: 0, star: 1 });
    }
    courseReviews.reviewsStars = reviewsStars;
    return courseReviews;
  }
  return false;
};
